import { inject } from "vue";
import { FormItemInjectionKey } from "./const";

export function useFormItemCheck() {
  const formItem = inject(FormItemInjectionKey, undefined);
  return (error?: boolean) => {
    formItem?.checkPorp(error);
  };
}
